import { useReportWebVitals } from 'next/web-vitals';
import { AnalyticsController } from 'analytics/analytics-controller';

/**
 * WebVitals component that tracks web vitals and sends them to the analytics controller
 */
export function WebVitals() {
  useReportWebVitals(metric => {
    AnalyticsController.trackWebVitals(metric);
  });
  return null;
}